import React from 'react'
import AnnouncementIcon from '@material-ui/icons/Announcement'
import { Translate } from 'react-localize-redux'
import SubLink from 'containers/SubLink'
import PropTypes from 'prop-types'
import { TeaserHead, TeaserFab, TeaserButton } from './styledComponents'

const TeaserHeader = ({ children, buttonLabel, isMessageTag }) => {
  // @todo Teaser header is hidden for now as needs discussion
  const isTeaserEnabled = false

  return (
    <>
      {isTeaserEnabled && (
        <TeaserHead>
          <TeaserFab variant="extended" color="primary">
            <AnnouncementIcon />
          </TeaserFab>
          {isMessageTag === true ? (
            <Translate id="teasers.message-pro" />
          ) : (
            <Translate id="teasers.message-plus" />
          )}
          <TeaserButton
            component={SubLink}
            // @fixme: should use CLUB_SUBSCRIPTION_ROUTE with populated clubUuid param
            // to={TEAM_SUBSCRIPTION_ROUTE}
            variant="contained"
            color="default"
          >
            {buttonLabel}
          </TeaserButton>
          {children}
        </TeaserHead>
      )}
    </>
  )
}

TeaserHeader.defaultProps = {
  buttonLabel: <Translate id="teasers.button" />,
  isMessageTag: true,
  children: <div />
}

TeaserHeader.propTypes = {
  children: PropTypes.node,
  isMessageTag: PropTypes.bool,
  buttonLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape()
  ]),

}

export default TeaserHeader
